/* hej-lokale-balk — gedrag van de vaste balk buiten het productraster, en van het uitklappaneel (2026-10-12).
 *
 * 1. Balken met data-hej-balk-los (sections/hej-lokale-balk.liquid: hubs, overzicht, gids, keuzehulp): opnieuw
 *    uitlijnen bij een andere breedte, matglas zodra de balk vastzit, en het uitklapmenu op de telefoon. Op de
 *    collectiepagina's doet assets/hej-acg-local-nav.js dat, maar dat leest de instellingen van het productraster.
 * 2. Elke uitklapbalk (.hej-acg-local-nav--uitklap, meer dan vijf links): het paneel achter het pijltje naast de
 *    titel, vanaf 601px. Exact het mechanisme van de zakelijke balk (assets/hej-zakelijk-sticky.js): klik op het
 *    pijltje opent en sluit, het paneel schuift open onder de balk, de pagina eronder krijgt een waas; de muis op dat
 *    waas sluit met 200 ms speling (zodat een schuin muispad naar een link niet afbreekt), klikken buiten de balk, op
 *    een link of Escape sluit ook.
 * De plaatsing (naar <body>, vóór de eerste tekening) gebeurt inline in snippets/hej-lokale-balk.liquid. Het waas van
 * het paneel wordt hier wel aan <body> toegevoegd, maar is tot het openen onzichtbaar (opacity 0, visibility hidden).
 * hej-preflight: verplaatsing raakt geen zichtbaar element */
(function () {
  var plaatsing = window.hejAcgLokaleNav;
  if (!plaatsing) return;
  var breed = window.matchMedia('(min-width: 601px)');

  document.querySelectorAll('.hej-acg-local-nav[data-hej-balk-los]').forEach(function (nav) {
    plaatsing.plaats(nav);
    var frame = 0;
    function lijnUit() { cancelAnimationFrame(frame); frame = requestAnimationFrame(function () { plaatsing.lijnUit(nav); }); }
    lijnUit();
    window.addEventListener('resize', lijnUit, { passive: true });
    var menu = document.querySelector('.hej-dnav-row');
    if ('ResizeObserver' in window && menu) new ResizeObserver(lijnUit).observe(menu);

    var frameKleur = 0;
    function kleur() { cancelAnimationFrame(frameKleur); frameKleur = requestAnimationFrame(function () { nav.classList.toggle('is-vast', nav.getBoundingClientRect().top <= 0); }); }
    kleur();
    window.addEventListener('scroll', kleur, { passive: true });

    var knop = nav.querySelector('.hej-acg-local-nav-toggle');
    if (!knop) return;
    var links = nav.querySelector('.hej-acg-local-nav-links');
    var waas = document.body.querySelector(':scope > .hej-acg-local-nav-backdrop') || nav.querySelector('.hej-acg-local-nav-backdrop');
    function dicht() {
      nav.classList.remove('is-open');
      knop.setAttribute('aria-expanded', 'false');
      if (waas) { waas.classList.remove('is-open'); waas.style.top = ''; }
    }
    knop.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !nav.classList.contains('is-open');
      dicht();
      if (!open) return;
      nav.classList.add('is-open');
      knop.setAttribute('aria-expanded', 'true');
      if (waas && links) requestAnimationFrame(function () { waas.style.top = links.getBoundingClientRect().bottom + 'px'; waas.classList.add('is-open'); });
    });
    document.addEventListener('click', function (e) { if (!nav.contains(e.target)) dicht(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dicht(); });
    if (waas) waas.addEventListener('click', dicht);
  });

  document.querySelectorAll('.hej-acg-local-nav--uitklap').forEach(function (nav) {
    var pijl = nav.querySelector('.hej-acg-local-nav-pijl');
    if (!pijl || pijl.hasAttribute('data-hej-klaar')) return;
    pijl.setAttribute('data-hej-klaar', '');
    var waas = document.createElement('div');
    waas.className = 'hej-acg-local-nav-meerwaas';
    waas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(waas);

    function isOpen() { return nav.classList.contains('is-meer-open'); }
    function sluit() {
      if (!isOpen()) return;
      nav.classList.remove('is-meer-open');
      waas.classList.remove('is-open');
      pijl.setAttribute('aria-expanded', 'false');
    }
    var timer = null;
    function planSluiten() { clearTimeout(timer); timer = setTimeout(sluit, 200); }
    function stopSluiten() { clearTimeout(timer); }
    function open() {
      stopSluiten();
      waas.style.top = Math.max(0, nav.getBoundingClientRect().bottom) + 'px';
      nav.classList.add('is-meer-open');
      waas.classList.add('is-open');
      pijl.setAttribute('aria-expanded', 'true');
    }
    pijl.addEventListener('click', function (e) { e.stopPropagation(); if (isOpen()) sluit(); else open(); });
    nav.addEventListener('click', function (e) { if (e.target.closest('.hej-acg-local-nav-meer .hej-acg-local-nav-link')) sluit(); });
    nav.addEventListener('mouseenter', stopSluiten);
    waas.addEventListener('click', sluit);
    waas.addEventListener('mouseenter', planSluiten);
    document.addEventListener('click', function (e) { if (isOpen() && !nav.contains(e.target)) sluit(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) { sluit(); pijl.focus(); } });
    var wacht = false;
    function bij() {
      if (wacht) return;
      wacht = true;
      requestAnimationFrame(function () {
        wacht = false;
        if (!breed.matches) { sluit(); return; }
        if (isOpen()) waas.style.top = Math.max(0, nav.getBoundingClientRect().bottom) + 'px';
      });
    }
    window.addEventListener('resize', bij, { passive: true });
    window.addEventListener('scroll', bij, { passive: true });
  });
})();
